import { render, staticRenderFns } from "./PageNotFoundView.vue?vue&type=template&id=ae76bc56&scoped=true&"
import script from "./PageNotFoundView.vue?vue&type=script&lang=ts&"
export * from "./PageNotFoundView.vue?vue&type=script&lang=ts&"
import style0 from "./PageNotFoundView.vue?vue&type=style&index=0&id=ae76bc56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae76bc56",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VBtn,VCard,VContainer,VDivider})
